import { parse } from 'qs';
import { useMemo } from 'react';

export const useQueryParams = ({
  parseOptions,
  location = window.location,
} = {}) => {
  const { search } = location;

  return useMemo(
    () =>
      parse(search, {
        ...parseOptions,
        ignoreQueryPrefix: true,
      }),
    [search, parseOptions],
  );
};
